<template>
  <!-- closeOnAutoApplyは日付の設定後、時間の設定もさせたいのでapply後にcloseしないようにしている -->
  <Datepicker
    :locale="ja"
    :weekStart="0"
    v-model="value"
    autoApply
    :teleport="true"
    :start-time="{ hours: 0, minutes: 0 }"
    :disabled="disabled"
    :format="format"
    :maxDate="maxDate"
    :minDate="minDate"
    :minutesIncrement="minutesIncrement"
    :clearable="clearable"
    :ui="ui"
    :flow="{ steps: flow }"
    :config="{ closeOnAutoApply: false }"
  >
    <template #clock-icon>時間を設定する</template>
    <template #calendar-icon>日付を設定する</template>
    <template #input-icon><IconCalendar :class="$style.icon" /></template>
  </Datepicker>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import {
  VueDatePicker as Datepicker,
  type UIConfig,
} from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import { ja } from 'date-fns/locale'
import IconCalendar from '@/components/icons/IconCalendar.vue'

const props = withDefaults(
  defineProps<{
    modelValue: Date | null
    maxDate?: Date
    minDate?: Date
    minutesIncrement?: number
    inputClassName?: string
    format?: string
    clearable?: boolean
    disabled?: boolean
    flow?: (
      'month' | 'year' | 'calendar' | 'time' | 'minutes' | 'hours' | 'seconds'
    )[]
  }>(),
  {
    format: 'yyyy/MM/dd HH:mm',
    disabled: false,
    flow: () => ['calendar'],
  }
)

const emit = defineEmits<{
  (event: 'update:modelValue', value: Date | null): void
}>()

const value = computed({
  get(): Date | null {
    return props.modelValue
  },
  set(value: Date | null): void {
    emit('update:modelValue', value)
  },
})

const ui = computed<Partial<UIConfig> | undefined>(() => {
  return props.inputClassName
    ? {
        input: props.inputClassName,
      }
    : undefined
})
</script>

<style lang="scss" module>
.icon {
  height: 20px;
  width: auto;
  margin-left: 10px;
  color: $color-text-and-object-high-emphasis;
}
</style>
